/*
 * Entity identifier component
 */
import React from "react";

import TextField from "./text_field.jsx";
import Setting from './setting.jsx';

export default class AdaliaMEEntityIdentifier extends TextField {
  static disallowMultiple() {
    return true;
  }

  static get TYPE() {
    return "adalia_me_entity_identifier";
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: "component_title_adalia_me_entity_identifier",
      placeholder: "field_entity_identifier_placeholder",
      description: "field_default_description",
      help: null,
    };
  }

  static lockedSettings() {
    return {
      required: true,
      lockEditWhenPrefilled: true,
      validations: { dataType: "string", format: "uuid" },
    };
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      name: "entity_id",
      cloneable: false,
      reportKey: "entity_id",
      ...this.lockedSettings(),
    });
  }

  isReadOnlyAnswer() {
    return true;
  }

  renderSettings() {
    return (
      <div>
        <Setting.TextField
          name="label"
          label={I18n.t("field_label", { scope: "fe" })}
          value={this.getText("label")}
          onChange={this.updateSettings}
        />
        <Setting.LongTextField
          name="description"
          label={I18n.t("field_description", { scope: "fe" })}
          value={this.getText("description")}
          onChange={this.updateSettings}
        />
        <Setting.LongTextField
          name="help"
          label={I18n.t("field_help", { scope: "fe" })}
          value={this.getText("help")}
          onChange={this.updateSettings}
        />
        <Setting.TextField
          name="reportKey"
          label={I18n.t("field_report_key", { scope: "fe" })}
          value={this.props.content.reportKey}
          description={I18n.t("field_report_key_description", { scope: "fe" })}
          {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
        />
      </div>
    );
  }

  beforeUpdateSettings(content) {
    content = { ...content, ...this.constructor.lockedSettings() };
  }
}
